define([
    'language/resource',
    'authui/iamUtils',
    'base/utils/cookie',
    'base/js/resetpwd/controllers/resetPwd'
], function (i18n, iamUtils, cookieOp, ResetPwd) {
    'use strict';

    function CustomizedResetPwd($scope, securityPolicy) {

        ResetPwd.call(this, $scope, securityPolicy, i18n, iamUtils);

        try {
            _ozprm = 'userid=' + cookieOp.getCookie('userId');
            cookieOp.delCookie('userId');
            // require(["https://sstatic.huaweicloud.com/static/js/o_code.js"]);
        }
        catch (e) {

        }
    };
    ResetPwd.prototype.customizedInitResetPage = function($scope, userInfo){
        var me= this;
        var ipIsInternational = iamUtils.ipIsInternational();
        if(!ipIsInternational) return;
        $scope.model.verifyTypeValue = userInfo.email;
        $scope.model.verifyTypeLabel = i18n('resetPwd.mailbox');
        $scope.model.msgCodeLabel = i18n('resetPwd.emailMsgCode');
        $scope.model.verifyTypeBtn = i18n('resetPwd.byPhone');
        $scope.model.emailMsgCodeBtnHandler = me.msgCodeBtnHandler($scope, i18n('resetPwd.getEmailMsgCode'), true);
        $scope.model.smsMsgCodeBtnHandler =  me.msgCodeBtnHandler($scope, i18n('resetPwd.getSmsMsgCode'), false);
        $scope.model.verifyType = 'email';
    }
    $.extend(CustomizedResetPwd.prototype, ResetPwd.prototype);
    //当前用户是香港国际站点的用户时

    CustomizedResetPwd = ['$scope', 'securityPolicy', CustomizedResetPwd];

    var loginModule = angular.module('authui.config');
    loginModule.controller('authui.resetPwd.ctrl', CustomizedResetPwd);
    
    return CustomizedResetPwd;
});



// WEBPACK FOOTER //
// ./public/hws/js/resetpwd/controllers/resetPwd.js